import React from "react";

export const StopIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <rect x="2" y="2" width="6" height="6" rx="1" fill="#002E19"/>
  </svg>
);
